// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Y0kY","paramInput":"JobSimulator_paramInput__14-f3","input":"JobSimulator_input__wCK3U"};